import React from 'react';

const PrimaryButton = ({
    text,
    customClass,
    disabled,
    onClick,
    type
}) => {
    return (
        <>
            <button
                type={type}
                // disabled={disabled}
                onClick={onClick}
                className={`w-fit h-fit text-white bg-[--primary] font-medium rounded-lg text-sm px-5 py-2.5 text-center hover:shadow-md ${ customClass }`}
            >
              {text}
            </button>
        </>
    )
}


export default PrimaryButton;